import logo from "../aws/logo.svg";
import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { escapeRegexLiteral } from "../urlPatternConversion";

export const amazonCognito = defineConnector({
  identifier: "amazonCognito",
  name: "Amazon Cognito",
  tagLine: "Authorized user pool profiles",
  logo,
  tags: ["identity"],
  protocol: "http",
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `${escapeRegexLiteral(`https://${domain}/oauth2/userInfo`)}(?:\\?.*)?$`
      : "",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your user pool domain",
      items: [
        {
          kind: "hostname",
          label: "User pool domain",
          required: true,
          placeholder: "example.auth.us-east-1.amazoncognito.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    ...oauthSetupSteps({
      identifier: "amazonCognito",
      registrationUrl:
        "https://console.aws.amazon.com/cognito/v2/idp/user-pools",
      scopes: ["openid", "profile"],
      instructions:
        "Configure an app client with a client secret, authorization code grant, and the requested scopes. This connector reads the authorized user’s profile; use the AWS connector for administrative Cognito APIs.",
    }),
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: ({ domain }) => `https://${domain}/oauth2/authorize`,
    tokenEndpoint: ({ domain }) => `https://${domain}/oauth2/token`,
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => ["openid", "profile"],
    pkce: () => true,
  },
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/oauth2/userInfo`,
  },
});
